@switch (mode()) {
  @case ('mobile') {
    <div class="main-container flex-col gap-24">
      <div class="flex-row justify-center w100">
        <div class="w100 p-16 border-box max-w-200">
          <vl-logo textColor="var(--color-on-background)"/>
        </div>
      </div>
      <div class="flex-col w100 grow p-12 border-box">
        <div class="justup-card up-3 border-box">
          <div class="flex-col p-12 gap-32 w100">
            <div class="flex-row w100 justify-center">
              <span class="headline on-background">{{ 'documents.select' | trans }}</span>
            </div>
            <div class="flex-row border-box w100 justify-center">
              @if (uploading()) {
                <div>
                  <ng-container *ngTemplateOutlet="uploadTemplate"></ng-container>
                </div>
              } @else if (processing()) {
                <ng-container *ngTemplateOutlet="processTemplate"></ng-container>
              } @else {
                <div (click)="fileUpload.click()" class="photo-button">
                  <mat-icon class="photo-icon">add_photo_alternate</mat-icon>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

  }
  @case ('desktop') {
    @if (!readOnly() && !uploading()) {
      <div class="h100 align-center justify-center flex-row gap-4">
        <vl-chips
          #menuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="uploadMenu"
          (action)="menuTrigger.openMenu()"
          iconLeft="add_photo_alternate"
        ></vl-chips>

        <mat-menu #uploadMenu="matMenu">
          <button mat-menu-item (click)="fileUpload.click()">
            <div class="flex-row gap-8 align-center">
              <span class="material-symbols-outlined">upload_file</span>
              <span class="body-1">{{ 'documents.import' | trans }}</span>
            </div>
          </button>
          <button mat-menu-item (click)="qrLinkWrapper.openQrCode()">
            <div class="flex-row gap-8 align-center">
              <span class="material-symbols-outlined">qr_code_scanner</span>
              <span class="body-1">{{ 'documents.remote_photo' | trans }}</span>
            </div>
          </button>
        </mat-menu>

        <vl-qr-link-wrapper
          #qrLinkWrapper
          [type]="TypeQrLink.PHOTO"
          [hidden]="true"
          (completed)="onQrCompleted($event)"
        />
      </div>
    }
    @if (uploading()) {
      <ng-container *ngTemplateOutlet="uploadTemplate"></ng-container>
    } @else if (processing()) {
      <ng-container *ngTemplateOutlet="processTemplate"></ng-container>
    }
    @if (initing()) {
      <ng-container *ngTemplateOutlet="initTemplate"></ng-container>
    }
  }
}

<input type="file" [accept]="acceptType()" class="file-input" (change)="onFileSelected($event)" #fileUpload>

<ng-template #uploadTemplate>
  <div class="flex-col w100 gap-4 p-4">
    <span class="body-2 on-background-alt">{{ 'documents.uploading' | trans }}  {{ uploadPercent() }}%</span>
    <div class="w100 flex min-w-100">
      <mat-progress-bar class="w100" [value]="uploadPercent()"></mat-progress-bar>
    </div>
  </div>
</ng-template>
<ng-template #processTemplate>
  <div class="flex-col w100 gap-4 p-4">
    <span class="body-2 on-background-alt">{{ 'documents.processing' | trans }}  {{ processPercent() }}%</span>
    <div class="w100 flex min-w-100">
      <mat-progress-bar class="w100" [value]="processPercent()"></mat-progress-bar>
    </div>
  </div>
</ng-template>

<ng-template #initTemplate>
  <div class="flex-col w100 gap-4 p-4">
    <span class="body-2 on-background-alt">{{ 'documents.initing' | trans }}  {{ initProgressPercent() }}%</span>
    <div class="w100 flex min-w-100">
      <mat-progress-bar class="w100" [value]="initProgressPercent()"></mat-progress-bar>
    </div>
  </div>
</ng-template>
